import React from 'react';
import SecondaryTitle from "../../Components/SecondaryTitle";
import Text from "../../Components/Text";

const ApplicationInformation = (props) => {
    const {
        data = {
            'title':        '',
            'first_name':   '',
            'last_name':    '',
        },
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Application information</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-sm-6 ps-0'}>
                    <Text className={'fw-bold'}>This application has been submitted by:</Text>
                </div>
                <div className={'col-sm-6 ps-0'}>
                    <Text>{data[0].title} {data[0].first_name} {data[0].last_name}</Text>
                </div>
            </div>
        </React.Fragment>
    );
}

export default ApplicationInformation;
